import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export function FormField({
  input,
  meta,
  label,
  required,
  addon,
  append,
  children,
  labelChildren
}) {
  const classes = classNames("form-group", {
    "has-error": meta.touched && meta.invalid
  });
  const asterisk = required && <sup className="small text-danger">*</sup>;

  const errors =
    meta.touched &&
    meta.invalid &&
    meta.error.map(m => (
      <span className="help-block" key={m}>
        {m}
      </span>
    ));

  const getAddOns = () => {
    if (addon) {
      return (
        <div className="input-group">
          <span className="input-group-addon">{addon}</span>
          {children}
        </div>
      );
    }

    if (append) {
      return (
        <div className="input-group">
          {children}
          <span className="input-group-addon">{append}</span>
        </div>
      );
    }

    return children;
  };

  return (
    <div className={classes}>
      <div>
        <label className="control-label" htmlFor={input.name}>
          {label}
          {asterisk}
          {labelChildren}
        </label>
        {getAddOns()}
        {errors}
      </div>
    </div>
  );
}

FormField.propTypes = {
  input: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
  meta: PropTypes.shape({
    invalid: PropTypes.bool,
    error: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  labelChildren: PropTypes.node,
  addon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  append: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  required: PropTypes.bool
};

export default function formField(Component) {
  return props => (
    <FormField {...props}>
      <Component {...props} />
    </FormField>
  );
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/formField.jsx